'use strict';

import angular from 'angular';
import 'ui-select';
import 'angular-bootstrap';
import './shortCodesServices';

const shortCodesControllers = angular.module('applicationModule.shortCodesControllers', [
    'applicationModule.shortCodesServices',
    'ui.bootstrap',
    'ui.select'
]);

shortCodesControllers.controller('ShortCodesController', ['$scope', '$rootScope', '$stateParams', '$state', '$filter', 'growl', 'NgTableParams', 'ShortCodes', 'AppsoupAPI', 'Permissions', '$window', function ($scope, $rootScope, $stateParams, $state, $filter, growl, NgTableParams, ShortCodes, AppsoupAPI, Permissions, $window) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('short_codes');
    const appId = $stateParams.application_id;
    $scope.search = {};

    $scope.typeOptions = {
        'html': 'HTML',
        'category_seo': 'CATEGORY_SEO'
    };

    $scope.tableParams = new NgTableParams(AppsoupAPI.getIdAscTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return ShortCodes.getList(appId, params._params).then(function (response) {
                params.total(response.shortcodes.total);
                params.count(response.shortcodes.per_page);
                params.page(response.shortcodes.current_page);

                return response.shortcodes.data;
            }).finally(function () {
                $scope.isLoading = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeShortCode = function (id) {
        ShortCodes.remove(id).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.SHORT_CODES.SUCCESS.DELETED');
                $scope.tableParams.reload();
                //$scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.SHORT_CODES.ERROR.DELETED');
            }
        });
    };

    $scope.searchShortCodes = function (search) {
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
    };
    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
    };
    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);

    $scope.copyToClipboard = function (text) {
        const copyElement = $window.document.createElement('textarea');
        copyElement.style.position = 'fixed';
        copyElement.style.opacity = '0';
        copyElement.textContent = text;
        const body = $window.document.getElementsByTagName('body')[0];
        body.appendChild(copyElement);
        copyElement.select();
        $window.document.execCommand('copy');
        body.removeChild(copyElement);
    };

}]);

shortCodesControllers.controller('ShortCodeController', ['$scope', '$rootScope', '$stateParams', '$state', '$translate', '$filter', 'growl', 'NgTableParams', '$locale', 'ShortCodes', 'AppsoupAPI', 'Permissions', '$window', function ($scope, $rootScope, $stateParams, $state, $translate, $filter, growl, NgTableParams, $locale, ShortCodes, AppsoupAPI, Permissions, $window) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('short_codes');
    const appId = $stateParams.application_id;

    $scope.tags = [];
    $scope.headerTitle = [];
    $scope.editMode = angular.isDefined($stateParams.shortCodeId);

    $scope.typeOptions = [{value: 'html', name: 'HTML'}, {value: 'category_seo', name: 'CATEGORY_SEO'}];

    $scope.shortCode = {
        app_id: appId,
        type: $scope.typeOptions[0].value
    };

    if ($scope.editMode) {
        $scope.isLoading = true;
        ShortCodes.get($stateParams.shortCodeId).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.shortCode = data.shortcode;
                $scope.headerTitle.push('-');
                $scope.headerTitle.push(' ');
                $scope.headerTitle.push($scope.shortCode.name);
            } else {
                growl.error('MODULES.SHORT_CODES.ERROR.GET_DATA');
                $state.go('appsoup.application.short_codes', {application_id: appId});
            }
        }).catch(function () {
            $state.go('appsoup.application.short_codes', {application_id: appId});
            growl.error('ERROR.EMPTY_DATA');
        }).finally(function () {
            $rootScope.doingResolve = false;
            $scope.isLoading = false;
        });
    }

    $scope.searchTags = function (text) {
        text = $filter('removeSpecial')(text);

        ShortCodes.search(appId, text).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.tags = data.tags;
            } else {
                growl.error(data["error"]);
            }
        });
    };
    $scope.changeTags = function () {
        if (angular.isDefined($scope.shortCode.tags)) {
            var tempTags = [];
            angular.forEach($scope.shortCode.tags, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tempTags.indexOf(value) === -1) {
                    tempTags.push(value);
                }
            });
            $scope.shortCode.tags = tempTags;
        }
    };

    $scope.save = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        ShortCodes.save($scope.shortCode, $scope.editMode).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.SHORT_CODES.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                $state.go('appsoup.application.short_codes', {application_id: appId});
            } else {
                if (typeof data.errors === 'object') {
                    $scope.formErrors = data.errors.shortcode;
                } else {
                    growl.error('MODULES.SHORT_CODES.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                }
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.copyToClipboard = function (text) {
        const copyElement = $window.document.createElement('textarea');
        copyElement.style.position = 'fixed';
        copyElement.style.opacity = '0';
        copyElement.textContent = text;
        const body = $window.document.getElementsByTagName('body')[0];
        body.appendChild(copyElement);
        copyElement.select();
        $window.document.execCommand('copy');
        body.removeChild(copyElement);
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.short_codes', {application_id: appId});
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'type': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'shortcode': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'content': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}]
    };

}]);

export default shortCodesControllers;
